
<div style="display:flex;justify-content:space-between">
    <h1 mat-dialog-title>Wybierz design!</h1>
   <img src="/images/icons/clear-black.png" (click)="closeClick()" style="width:20px;height:20px;cursor:pointer" alt="Zamknij okienko"/>
</div>
<div mat-dialog-content>
    <app-video></app-video>
</div>
